import ApiService from './ApiService'
import type { MasterPasswordMetadata } from './CryptoService'

export type SetupMasterPasswordPayload = MasterPasswordMetadata

export async function apiSetupMasterPassword(payload: SetupMasterPasswordPayload) {
    return ApiService.fetchDataWithAxios<{ message: string }>({
        url: '/app/v1/master-password/setup',
        method: 'post',
        data: payload,
    })
}

/**
 * Fetch the authenticated user's master-password KDF metadata (salt, KDF
 * params, and password verifier) from the backend so the client can
 * re-derive the master key on unlock.
 *
 * Returns the full `MasterPasswordMetadata` shape on success.
 * Throws (rejects) with an AxiosError if the user has no master password
 * configured (404) or if the request otherwise fails.
 */
export async function apiGetMasterPasswordMeta() {
    return ApiService.fetchDataWithAxios<MasterPasswordMetadata>({
        url: '/app/v1/master-password/meta',
        method: 'get',
    })
}

